import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';
import { CmpsWidgetModule } from '../widget/widget.module';

import { PulseComponent } from './pulse.component';
import { TranslationIdMap } from './pulse.i18n';
import { PulseRoutes } from './pulse.route';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(PulseRoutes),
        CmpsWidgetModule,
    ],
    declarations: [PulseComponent],
    exports: [PulseComponent],
})
export class CmpsPulseModule {}
